<script setup lang="ts">
import { ChartData } from '@/composables/useSectorStats';
import StatCard from './StatCard.vue';

defineProps<{ stats: ChartData }>();
</script>

<template>
  <section class="grid grid-cols-1 gap-3 sm:grid-cols-3">
    <StatCard
      :value="stats.totalDays"
      label="总记录天数"
      icon="📅"
    />
    <StatCard
      :value="stats.uniqueSectors"
      label="涉及板块数"
      icon="🎯"
    />
    <StatCard
      :value="stats.mostActive?.name ?? '-'"
      :sub-value="stats.mostActive ? `${stats.mostActive.score} 分` : ''"
      label="最活跃板块"
      icon="🏆"
      :highlight="true"
    />
  </section>
</template>
